var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _vm.search.length > 0
        ? _c("oaFromBox", {
            attrs: {
              btnText: "导出",
              isAddBtn: true,
              search: _vm.search,
              title: "审批记录",
              total: _vm.total,
              viewSearch: _vm.viewSearch,
            },
            on: { addDataFn: _vm.getExportData, confirmData: _vm.confirmData },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }